import { Circle } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { InvestigationLabels } from '@/frontend/features/Fde/investigations/types'

export default function OutcomeBadge({ code, copy }: { code: string; copy: InvestigationLabels }) {
  return <span className={cn('inline-flex items-center gap-2 text-xs', code === 'opportunity' ? 'text-emerald-700 dark:text-emerald-400' : 'text-muted-foreground')}>
    <Circle className="size-1.5 shrink-0 fill-current" aria-hidden />{copy[`outcome_${code}`] || copy.outcome_inconclusive}
  </span>
}
